/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'bi/content_apps/common/ui/list_columns/Text',
	'bi/commons/utils/JQueryExt'
], function(Text) {
	'use strict';

	var LegacyAppsText = Text.extend({

		createEllipseCell: function(nParent, sData, oData) {
			const $div = LegacyAppsText.inherited('createEllipseCell', this, arguments);
			$div.addClass(oData.type);
			return $div;
		}

	});

	return LegacyAppsText;
});